import React, { useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../../actions";
import Mensagens from "../../../components/Mensagens";

function BtnBuscarCnpj({ cnpj, onOk, ...props }) {
    const [loading, setLoading] = useState(false);
    return <a disabled={loading} style={{ fontWeight: "initial" }} onClick={() => {
        if (loading) return;
        setLoading(true);
        props.fetch().post(`apiexterna/consulta/cnpj/${cnpj?.replace(/\D/g, '')}`).then(async res => {
            const data = res.data;

            if (data?.status == "ERROR")
                Mensagens.showErro(data.message);
            else
                onOk(data);

            setLoading(false);
        }).catch(err => { Mensagens.showErro(err); setLoading(false); });
    }}>Buscar</a>;
}

export default connect(null, { fetch })(BtnBuscarCnpj);